import { VERIFICATION_COLUMNS } from "@/components/agents/agent-verifications";
import { DataTable } from "@/components/ui/data-table";
import { createFileRoute, useLoaderData } from "@tanstack/react-router";

/** `/agents/$slug/verifications` — Prokop's verdicts on the work items
 *  he tested. */
export const Route = createFileRoute("/_app/agents/$slug/verifications")({
  component: AgentVerifications,
});

function AgentVerifications() {
  const data = useLoaderData({ from: "/_app/agents/$slug" });
  return (
    <DataTable
      columns={VERIFICATION_COLUMNS}
      rows={data.verifications ?? []}
      rowKey={(v) => v.id}
      rowTestId={() => "verification-row"}
      density="compact"
      emptyState={
        <span data-testid="verifications-empty">
          No verifications yet — hand Prokop a work item in an internal-testing state.
        </span>
      }
    />
  );
}
